import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

export const AdministratorTicketingWebsiteAlertIssues = () => {
    const dispatch = useDispatch();

    const [ticketingWebsiteAlertIssues, setTicketingWebsiteAlertIssues] = useState([]);
    const [ticketingWebsiteAlertIssueCount, setTicketingWebsiteAlertIssueCount] = useState(0);
    const [skipCount, setSkipCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(1);
    const [areTicketingWebsiteAlertIssuesLoading, setAreTicketingWebsiteAlertIssuesLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");

    const [showDialog, setShowDialog] = useState(false);
    const [dialogContent, setDialogContent] = useState("");

    const ViewDialogCell = (props) => {  
        const content = props.dataItem[props.field];
        
        return (
            <td>
                {content ? <Button fillMode="link" type={"button"} onClick={() => viewDialog(content)}>View</Button> : ""}
            </td>
        );
    };

    const viewDialog = (content) => {
        setDialogContent(content);
        setShowDialog(true);
    }

    const getTicketingWebsiteAlertIssues = (newPageNumber) => {
        setAreTicketingWebsiteAlertIssuesLoading(true);

        const dataItem = {
            pageNumber: newPageNumber,
        };
    
        fetch(`/api/administrator/ticketingwebsitealertissues`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setAreTicketingWebsiteAlertIssuesLoading(false);                
                setItemsPerPage(result.ticketingWebsiteAlertIssuesPerPage);
                setSkipCount(result.ticketingWebsiteAlertIssuesPerPage * (result.pageNumber - 1));
                setTicketingWebsiteAlertIssueCount(result.totalTicketingWebsiteAlertIssueCount);                
                setTicketingWebsiteAlertIssues(result.ticketingWebsiteAlertIssues);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreTicketingWebsiteAlertIssuesLoading(false);
                setLoadingError(error.message);
            });
    }

    const pageChange = (event) => {
        const newPageNumber = (event.page.skip / event.page.take) + 1;
        getTicketingWebsiteAlertIssues(newPageNumber);
    };

    useEffect(() => {
        document.title = "Ticketing Website Alert Issues";

        getTicketingWebsiteAlertIssues();
    }, []);

    return (
        <div>
            {areTicketingWebsiteAlertIssuesLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <>
                    <Grid
                        data={ticketingWebsiteAlertIssues}
                        resizable={true}
                        skip={skipCount}
                        take={itemsPerPage}
                        total={ticketingWebsiteAlertIssueCount}
                        pageable={true}
                        onPageChange={pageChange}
                        scrollable="none"
                    >
                        <Column field="ticketingWebsiteName" title={"Website"} />
                        <Column field="ticketingWebsiteAlertLabel" title={"Alert Label"} />
                        <Column field="dateCreated" title={"Date"} />
                        <Column field="isResolved" title={"Resolved"} />
                        <Column field="isAlertSuccessful" title={"Alert Successful"} />
                        <Column field="isEmailSentSuccessfully" title={"Email Successful"} />                        
                        <Column field="notes" title={"Notes"} cell={ViewDialogCell} />
                    </Grid>

                    {showDialog === false ? <></> :
                        <Dialog
                            title={"Notes"}
                            onClose={() => setShowDialog(false)}
                            width={"90vw"}
                        >
                            {dialogContent}
                        </Dialog>
                    }
                </>
            ) : <></>)
            }
        </div>
    );
}